var React = require('react');

function FooterReservations (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#323D74","fillRule":"evenodd"},[React.createElement("path",{"d":"M6.47 2l.1698.8939-.3822-.0759L1 30.455h10.8824L12.5575 34H59L52.9125 2H6.47zm2.4074 2.0223h42.396l5.3202 27.9554h-42.398L8.8773 4.0223zM7.4528 7.167l4.0455 21.2656H3.4074L7.4528 7.167z","key":0}),React.createElement("path",{"d":"M23 18h6v-2h-6zM31 18h12v-2H31z","key":1})]));
}

FooterReservations.defaultProps = {"width":"59","height":"34","viewBox":"0 0 59 34"};

module.exports = FooterReservations;

FooterReservations.default = FooterReservations;
